import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { MegaphoneIcon, TicketIcon, UserGroupIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';
import { FC } from 'react';
import { Link } from 'react-router-dom';

const GetStartedBannerForDealDashboard: FC<{
  dealId: string;
  syndicateId: string;
}> = ({ dealId, syndicateId }) => {
  const items = [
    {
      name: 'View your commitments',
      description: 'Keep track of all the commitments for this deal',
      href: `/syndicate-dashboard/${syndicateId}/deals/${dealId}/commitments`,
      iconColor: 'bg-pink-500',
      icon: TicketIcon,
    },
    {
      name: 'Manage invites',
      description: 'Invite investors to this deal and manage their access',
      href: `/syndicate-dashboard/${syndicateId}/deals/${dealId}/invites`,
      iconColor: 'bg-purple-500',
      icon: MegaphoneIcon,
    },
    {
      name: 'Edit your information',
      description: 'Update your deal details and settings',
      href: `/syndicate-dashboard/${syndicateId}/deals/${dealId}/information/basic-information`,
      iconColor: 'bg-yellow-500',
      icon: UserGroupIcon,
    },
  ];

  return (
    <div className="rounded-xl bg-gray-50 z-10 p-4">
      <h2 className="text-xl font-semibold leading-6 text-gray-700">Your deal dashboard</h2>
      <p className="mt-1 text-sm text-gray-500">
        View and manage your deal, invite investors, and edit your deal details.
      </p>
      <ul className="mt-6 divide-y divide-gray-200 rounded-lg px-4 bg-white">
        {items.map((item, itemIdx) => (
          <li key={itemIdx}>
            <Link to={item.href}>
              <div className="group relative flex items-start space-x-3 py-4">
                <div className="flex-shrink-0">
                  <span
                    className={classNames(
                      item.iconColor,
                      'inline-flex h-10 w-10 items-center justify-center rounded-lg'
                    )}
                  >
                    <item.icon aria-hidden="true" className="h-6 w-6 text-white" />
                  </span>
                </div>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-medium text-gray-900">
                    <a href={item.href}>
                      <span aria-hidden="true" className="absolute inset-0" />
                      {item.name}
                    </a>
                  </div>
                  <p className="text-sm text-gray-500">{item.description}</p>
                </div>
                <div className="flex-shrink-0 self-center">
                  <ChevronRightIcon
                    aria-hidden="true"
                    className="h-5 w-5 text-gray-400 group-hover:text-gray-500"
                  />
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default GetStartedBannerForDealDashboard;
